export default "__VITE_ASSET__4868c70d__"